import React, { useEffect, useRef } from 'react';
import styles from './AdSenseAd.module.css';
import useSubscriptionStatus from '../../../hooks/useSubscriptionStatus';

const AdSenseAd = ({ 
  adSlot, 
  adFormat = 'auto', 
  adLayout = '', 
  adLayoutKey = '',
  className = '',
  style = {},
  fullWidthResponsive = true,
  placement = 'banner' // 'banner', 'inline', 'footer'
}) => {
  const adRef = useRef(null);
  const { shouldShowAds, isLoading } = useSubscriptionStatus();

  useEffect(() => {
    // Only load ads if user should see ads (free users)
    if (!shouldShowAds || isLoading) {
      return; // Don't show ads for premium users or while loading
    }

    // Load AdSense script if not already loaded
    if (!window.adsbygoogle) {
      const script = document.createElement('script');
      script.async = true;
      script.src = 'https://pagead2.googlesyndication.com/pagead/js/adsbygoogle.js';
      script.setAttribute('data-ad-client', process.env.REACT_APP_ADSENSE_CLIENT_ID || 'ca-pub-YOUR-PUBLISHER-ID');
      document.head.appendChild(script);
    }

    // Initialize ad after component mounts
    const timer = setTimeout(() => {
      try {
        if (window.adsbygoogle && adRef.current) {
          window.adsbygoogle.push({});
        }
      } catch (error) {
        console.error('AdSense error:', error);
      }
    }, 100);

    return () => clearTimeout(timer);
  }, [adSlot, shouldShowAds, isLoading]);

  // Don't render if user has premium subscription or still loading
  if (!shouldShowAds || isLoading) {
    return null;
  }

  return (
    <div className={`${styles.adContainer} ${styles[placement]} ${className}`} style={style}>
      <div className={styles.adLabel}>Advertisement</div>
      <ins
        ref={adRef}
        className="adsbygoogle"
        style={{ display: 'block', ...style }}
        data-ad-client={process.env.REACT_APP_ADSENSE_CLIENT_ID || 'ca-pub-YOUR-PUBLISHER-ID'}
        data-ad-slot={adSlot}
        data-ad-format={adFormat}
        data-ad-layout={adLayout}
        data-ad-layout-key={adLayoutKey}
        data-full-width-responsive={fullWidthResponsive.toString()}
      />
    </div>
  );
};

export default AdSenseAd; 